'use client';

import Image from 'next/image';
import { useTranslations } from 'next-intl';
import notFoundIcon from '@images/ico_404.webp';
import { TrackedAnchor } from '@/components/ancher';
import { LINKS } from '@/constants';
import { useErrorPageTracking } from '@/hooks/useErrorPageTracking.hook';

// 시리즈 목록 페이지 에러 바운더리 — 렌더 중 예외가 화면(Next 에러 페이지)까지 올라가지 않도록
// fallback UI 를 보여준다. 노출 추적(view_error_page)·Sentry 전송(Slack 알림 없이)은
// 공용 훅이 담당한다(docs/plans/2026-08-03-error-page-tracking-convention.md).
export default function BlogSeriesListError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  const t = useTranslations('Blog.error');

  useErrorPageTracking('blog_series_list', error);

  return (
    <div className="flex flex-col items-center justify-center gap-6 pb-[100px] pt-[200px] text-center lg:pb-[150px] lg:pt-[250px]">
      <Image src={notFoundIcon} alt="Error Icon" width={100} height={100} />
      <div className="flex flex-col items-center justify-center gap-3">
        <h1 className="text-h6 font-semibold text-3b-text-primary lg:text-h4">
          {t('title')}
        </h1>
        <p className="max-w-[350px] text-body2 font-medium text-3b-text-secondary md:max-w-[450px] lg:text-sh2">
          {t('message')}
        </p>
        {process.env.NEXT_PUBLIC_PHASE === 'dev' && error.message && (
          <pre className="mt-2 max-w-[600px] overflow-x-auto rounded-lg bg-3b-background-medium p-4 text-left text-[13px] leading-5 text-3b-text-secondary">
            {error.message}
          </pre>
        )}
      </div>
      <TrackedAnchor
        label="back-to-blog-list"
        position="main_content"
        href={LINKS.BLOG}
        className="block rounded-[30px] bg-3b-background-medium px-4 py-2 lg:rounded-[40px] lg:px-6 lg:py-3"
      >
        <span className="text-sh2 font-semibold text-3b-text-primary">
          {t('backLabel')}
        </span>
      </TrackedAnchor>
    </div>
  );
}
